import * as R from "ramda";

import { getters } from "./model";

export const getActiveSnackbar = R.compose(
  R.head,
  getters.snackbars
);
